import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import SearchInput from '@/components/common/search-input';
import AppHeaderMenu from '@/components/layouts/page-layout/app-header-menu';
import PageLayout from '@/components/layouts/page-layout/page-layout';
import SessionHeaderMenu from '@/components/sessions/session-list/session-header-menu';
import SessionList from '@/components/sessions/session-list/session-list';
import { useSessionUnreadCount } from '@/hooks/sessions/use-conversation-sessions';
import useUserPlatform from '@/hooks/use-user-platform';
import ROUTES from '@/routes';
import { setPanel } from '@/stores/layout-status';

export default function MessagesIndexRoute() {
  const { t } = useTranslation();
  const { isEmbedded } = useUserPlatform();
  const { data: sessionUnreadCount = 0 } = useSessionUnreadCount();

  return (
    <PageLayout
      key='nav.messages'
      title={t('nav.messages')}
      className='desktop:flex-1 desktop:pb-0'
      headerConfig={{
        headerLabel: t('nav.messages'),
        actions: (
          <>
            {sessionUnreadCount > 0 && <SessionHeaderMenu />}
            <AppHeaderMenu />
          </>
        ),
        showHeader: !isEmbedded,
        elementAfterNav: (
          <Link
            className='mx-3 block'
            to={ROUTES.SEARCH.$path()}
            onClick={() => setPanel('search')}>
            <SearchInput
              className='pointer-events-none'
              keyword=''
            />
          </Link>
        ),
      }}>
      <SessionList />
    </PageLayout>
  );
}
